import { Routes } from "@angular/router";
import { UnauthorizedComponent } from "./components/unauthorized/unauthorized.component";
import { KeycloakGuard } from "./core/guards/keycloak.guard";
import { roleGuard } from "./core/guards/role.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "marketing",
    pathMatch: "full",
  },
  {
    path: "project/:id/:name",
    loadComponent: () =>
      import("./routes/project/project.component").then(
        (m) => m.ProjectComponent
      ),
    canActivate: [KeycloakGuard,roleGuard],
    data: {
      roles: [
        "accello360-organization-owner",
        "accello360-project-owner",
        "accello360-project-user",
      ],
    },
  },
  {
    path: "project/:projectId/automation/:automationId/script/:scriptId/editor-view",
    loadComponent: () =>
      import("./routes/editor-view/editor-view.component").then(
        (m) => m.EditorViewComponent
      ),
    canActivate: [KeycloakGuard,roleGuard],
    data: {
      roles: [
        "accello360-organization-owner",
        "accello360-project-owner",
        "accello360-project-user",
      ],
    },
  },
  {
    path: "project/:id/:name/questionnaire-survey",
    loadComponent: () =>
      import("./routes/questionnaire-survey/questionnaire-survey.component").then(
        (m) => m.QuestionnaireSurveyComponent
      ),
    canActivate: [KeycloakGuard,roleGuard],
    data: {
      roles: [
        "accello360-organization-owner",
        "accello360-project-owner",
        "accello360-project-user",
      ],
    },
  },
  {
    path: "onboarding",
    loadChildren: () =>
      import("./routes/onboarding/onboarding-routes").then(
        (m) => m.onboardingRoutes
      ),
    canActivate: [roleGuard],
  },
  {
    path: "admin/organization",
    loadComponent: () =>
      import("./routes/admin-view/admin-view.component").then(
        (m) => m.AdminViewComponent
      ),
    data: {
      type: "organization",
      roles: ["accello360-global-administrator"],
    },
    canActivate: [KeycloakGuard, roleGuard],
  },
  {
    path: "admin/project",
    redirectTo: "user/project",
    pathMatch: "full",
  },
  {
    path: "user/project",
    loadComponent: () =>
      import("./routes/admin-view/admin-view.component").then(
        (m) => m.AdminViewComponent
      ),
    data: {
      type: "project",
      roles: [
        "accello360-global-administrator",
        "accello360-organization-owner",
        "accello360-project-owner",
        "accello360-project-user",
      ],
    },
    canActivate: [KeycloakGuard, roleGuard],
  },
  {
    path: "admin/prompt-templates",
    loadComponent: () =>
      import("./routes/prompt-templates/prompt-templates.component").then(
        (m) => m.PromptTemplatesComponent
      ),
    data: {
      roles: ["accello360-global-administrator"],
    },
    canActivate: [KeycloakGuard, roleGuard],
  },
  {
    path: "marketing",
    loadComponent: () =>
      import("./routes/admin-view/admin-view.component").then(
        (m) => m.AdminViewComponent
      ),
    data: { type: "organization", isMarketing: true },
    canActivate: [KeycloakGuard]
  },
  {
    path: "telemetry-dashboard",
    loadComponent: () =>
      import("./routes/telemetry-dashboard/telemetry-dashboard.component").then(
        (m) => m.TelemetryDashboardComponent
      ),
    canActivate: [KeycloakGuard, roleGuard],
    data: {
      roles: [
        "accello360-global-administrator",
        "accello360-organization-owner",
        "accello360-project-owner",
        "accello360-project-user",
      ],
    },
  },
  {
    path: "unauthorized",
    component: UnauthorizedComponent,
  },
];
